import { Paragraph, TextRun, AlignmentType } from 'docx'
import { ProcessingContext } from '../types'

/**
 * Process horizontal rule lines and return paragraph or null
 */
export function processHorizontalRule(
  trimmedLine: string,
  context: ProcessingContext
): Paragraph | null {
  if (trimmedLine === '---' || trimmedLine === '***' || trimmedLine === '___') {
    return new Paragraph({
      children: [new TextRun({ text: '―――――――――――――――――――――――――――――――――――――――', size: context.fontSize, color: '000000' })],
      alignment: AlignmentType.CENTER,
      spacing: { before: 240, after: 240 }
    })
  }
  return null
}